import React from "react";
import Icon from "@ant-design/icons";


const AttendanceAlertSvg = () => (
    <svg
        fill="currentColor"
        width="1em"
        height="1em"
        viewBox="0 0 64 65"
    >
        <path
            transform="translate(4 6.66667)"
            fillRule="evenodd"
            d="M28.344833 0C30.204834 0.0013333333 31.868834 0.96266669 32.798168 2.572L55.991501 42.741333C56.920834 44.352001 56.920834 46.274666 55.990166 47.885334C55.060833 49.495998 53.3955 50.457333 51.5355 50.457333L5.1528335 50.457333C3.2928333 50.457333 1.6275001 49.495998 0.69816673 47.885334C-0.23249991 46.274666 -0.23249991 44.352001 0.69683343 42.741333L23.888834 2.572C24.820833 0.96133333 26.484833 0 28.3435 0L28.344833 0ZM28.3435 5.5226665L5.4808335 45.124001L51.2075 45.124001L28.3435 5.5226665ZM28.008167 35.689201C29.504168 35.689201 30.716167 36.901199 30.716167 38.397202C30.716167 39.891865 29.504168 41.103867 28.008167 41.103867C26.5135 41.103867 25.3015 39.891865 25.3015 38.397202C25.3015 36.901199 26.5135 35.689201 28.008167 35.689201ZM28.051233 14.920267C29.523233 14.920267 30.717899 16.114933 30.717899 17.586933L30.717899 30.6936C30.717899 32.166935 29.523233 33.360268 28.051233 33.360268C26.579233 33.360268 25.384567 32.166935 25.384567 30.6936L25.384567 17.586933C25.384567 16.114933 26.579233 14.920267 28.051233 14.920267Z"
        />
    </svg>
);

const AttendanceAlertIcon = ({ className }) => (
    <Icon component={ AttendanceAlertSvg } className={ className } />
);

export default AttendanceAlertIcon;
